import styles from "./MypageInput.module.scss";
import { useState } from "react";
import { validateRequired, validateMaxlength } from "../../utils/validate";

const MypageTextAreaField = ({
  name,
  label,
  maxLength = null,
  register,
  validation = {},
  errors,
  watch,
  required = false,
  placeholder = "",
  isStatic = false,
  readOnly = false,
}) => {
  /**** バリデーションルール設定 ****/
  // 項目ごとのルール
  let txt_validation = validation;
  if (maxLength) {
    // 最大文字数が設定されていたら最大文字数バリデーションルール設定
    txt_validation = { ...txt_validation, ...validateMaxlength(maxLength) };
  }
  if (required) {
    // 必須項目なら必須バリデーションルール設定
    txt_validation = { ...txt_validation, ...validateRequired() };
  }

  const returnText = () => {
    const value = watch(name);
    return typeof value !== "undefined" &&
      value !== null &&
      value.length > 0 ? (
      value
    ) : (
      <p>&emsp;</p>
    );
  };

  return (
    <div className={styles.mypageform__block}>
      <div className={styles.mypageform__ttl}>
        {label}
        <span className={styles.mypageform__ttl__required}>
          {required && !isStatic ? "必須" : ""}
        </span>
      </div>
      <div
        className={`${styles.mypageform__field} ${isStatic ? "d-none" : ""}`}
      >
        <textarea
          className={`${styles.mypageform__textarea}
            ${errors[name] ? "is-invalid" : ""} ${
            isStatic ? "form-control-plaintext" : "form-control"
          }`}
          // maxLength={maxLength}
          {...register(name, txt_validation)}
          placeholder={placeholder}
          readOnly={isStatic || readOnly}
        />
        <>
          {errors[name] ? (
            <p className={`invalid-feedback ${styles.mypageform__msg}`}>
              {errors[name].message}
            </p>
          ) : (
            <></>
          )}
        </>
      </div>
      {/* 確認画面表示用 */}
      {isStatic && (
        <div className={`${styles.mypageform__label} ws-pre-wrap ps-4`}>
          {returnText()}
        </div>
      )}
    </div>
  );
};

export default MypageTextAreaField;
